module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-211.3e043972.jpg";